import { FetchResult, gql } from 'apollo-boost';
import { ISystem } from '../../../models/system';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation SaveSystem($input_data: SystemInput!) {
        system_save(input_data: $input_data) {
            success
        }
    }
`;

export async function saveSystem(system: ISystem): Promise<{ success: boolean }> {
    const result: FetchResult<{ system_save: { success: boolean } }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: {
            input_data: {
                uid: system.uid ? system.uid : null,
                min_mobile_version: system.minMobileVersion,
                mobile_update_link: system.mobileUpdateLink,
                mobile_paywall_on: system.mobilePaywallOn,
                mobile_payment_optional: system.mobilePaymentOptional,
                payment_optional_pause_period: system.paymentOptionalPausePeriod,
                number_of_sessions_before_paywall: system.numberOfSessionsBeforePaywall,
                org_support_on: system.orgSupportOn
            }
        },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.system_save;
}

